// Filtering listing all events ----------------------------------------- START
$('.loadfromajaxsearchevent').on('change', function() {
    $('body').addClass('is-loading');

    var data = $('#events-form').serialize();

    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': data + '&action=get_listing_events_search_action',
        success: function(response) {
            var res = JSON.parse(response);
            $('#events-results').empty().append(res);
            commentAjaxCallbackFunction();
        },
    }).always(function () {
        $('body').removeClass('is-loading');
    });
});
// Filtering listing all events ------------------------------------------- END

function commentAjaxCallbackFunction() {
    // Post Comments ------------------------------ START
    $(function() {

        $('.comment-form textarea#comment').attr('placeholder', ilioPost.postCommentPlaceholder);
        $('.comment-form textarea#comment').focus(function() {
            $(this).addClass('field-focused');
            $(this).parents('.comment-form').find('.form-submit').show();
        })
    });

    // Post Comments ------------------------------ END
}

// Pagination listing all events ---------------------------------------- START
$(document).on('click touch', '#events-pagination a', function(e) {
    e.preventDefault();

    var link = $(this).attr('href');

    var newLink = "";
    if (link.includes("page")) {
        newLink = link.substring(link.indexOf("page"));
    } else if (link.includes("?")) {
        newLink = link.substring(link.indexOf("?"));
    }

    var pageLink = $('#events-results').attr("data-url");

    var resultsLink = pageLink + newLink;

    $('#events-results').load(resultsLink + " #events-results > *", function () {

        function scrolltoTop() {
            var offsetTop = $("#events-results").offset().top;
            $('html, body').animate({ scrollTop: offsetTop - 100 }, 500);
        }

        scrolltoTop();
    });
});
// Pagination listing all events ------------------------------------------ END

// Buttons interested/participate on event ------------------------------ START
$(document).on('submit', '.form-event-participation', function(e) {
    e.preventDefault();
    $('body').addClass('is-loading');
    var button = this;

    var self = this;

    var otherButtonClass = $(button).hasClass("participation-btn")? "waiting-btn" : "participation-btn" ;

    var otherButton = $(this).find("." + otherButtonClass);

    var participationBtn = $(this).find(".participation-btn");

    // Set params
    var user = button.getAttribute('data-user-id');
    var event = button.getAttribute('data-event-id');
    var action = button.getAttribute('data-action');
    var action_function = '';

    // Determine which action to use
    if (action === 'participation') {
        action_function = 'create_participation';
    } else if (action === 'interested') {
        action_function = 'create_interest';
    }

    // Ajax call
    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&user_id=' + user + '&event_id=' + event + '&action=' + action_function,
        success: function(response) {
            var res = JSON.parse(response);
            swal({
                title: res.message.title,
                html: res.message.message,
                type: res.message.type
            });

            // Update participate/interest counter
            if (res.hasOwnProperty('count') && res.count !== null ) {
                if (res.count.hasOwnProperty('participation')) {
                    $('body').find('.event-listing__count--participate-' + res.count.event_id).text(res.count.participation);
                }

                if (res.count.hasOwnProperty('interest')) {
                    $('body').find('.event-listing__count--interest-' + res.count.event_id).text(res.count.interest);
                }
            }

            console.log(res);

            if (res.count.hasOwnProperty('status') && res.count.status == "1") { // Interested
                $(button).removeClass("tags-list__item--disabled");
                $(otherButton).removeClass("tags-list__item--waiting");
                $(otherButton).addClass("tags-list__item--disabled");
                $(otherButton).html(ilioPost.eventParticipatingWording);
                $(button).html(ilioPost.eventNoInterestingWording);
                if ($(button).attr("data-is-full") == 1) {
                    $(otherButton).html(ilioPost.eventJoinQueueWording);
                } else {
                    $(otherButton).html(ilioPost.eventParticipatingWording);
                }

            } else if (res.count.hasOwnProperty('status') && res.count.status == "2") { // Participating
                $(button).removeClass("tags-list__item--disabled");
                $(otherButton).addClass("tags-list__item--disabled");
                $(self).find('button[data-action="interested"]').html(ilioPost.eventInterestingWording);
                $(self).find('button[data-action="participation"]').html(ilioPost.eventNoParticipatingWording);

            }else if (res.count.hasOwnProperty('status') && res.count.status == "3") { // Waiting
                $(button).addClass("tags-list__item--waiting");
                $(button).html(ilioPost.eventWaitingWording);
                $(otherButton).addClass("tags-list__item--disabled");
                $(self).find('button[data-action="interested"]').html(ilioPost.eventInterestingWording);

            }else if (res.count.hasOwnProperty('status') && res.count.status == "allready_waiting") { // Allready waiting


            } else if (res.count.hasOwnProperty('status') && res.count.status == "0") {
                $(otherButton).addClass("tags-list__item--disabled");
                $(button).addClass("tags-list__item--disabled");
                $(self).find('button[data-action="interested"]').html(ilioPost.eventInterestingWording);
                $(self).find('button[data-action="participation"]').html(ilioPost.eventParticipatingWording);
            } else {
                $(button).addClass("tags-list__item--disabled");

                if (action === 'participation') {
                    participationBtn.html(ilioPost.eventParticipatingWording);
                    $(button).removeClass("tags-list__item--waiting");

                }

            }
        },
    }).always(function () {
        $('body').removeClass('is-loading');
    });
});

$(document).on('click touch', '.load-participate-popup, .load-interest-popup', function(e) {
    var target = $(this);
    var participating = 1;

    if ($(target).hasClass('load-participate-popup')) {
        participating = 1;
    } else {
        participating = 0;
    }

    var event_id = $(target).data('target');
    event_id = event_id.match(/\d+/)[0];

    var container;

    if (participating) {
        container = '.eventUserListResults-' + event_id + '-participate';
    } else {
        container = '.eventUserListResults-' + event_id + '-interest';
    }

    $(container).empty().append('<div class="text-center mt-3 rotate-spinner"><i class="fa fa-spinner"></i></div>');

    // Ajax call
    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&participating=' + participating + '&event_id=' + event_id + '&action=load_event_user_list_popup',
        success: function(response) {
            var res = JSON.parse(response);

            $(container).empty().append(res);
        },
    })
});

$(document).on('click touch', '.load-waiting-popup', function(e) {
    var target = e.target;

    var event_id = $(target).data('target');
    event_id = event_id.match(/\d+/)[0];

    var container = '.eventUserListResults-' + event_id + '-waiting';

    $(container).empty().append('<div class="text-center mt-3 rotate-spinner"><i class="fa fa-spinner"></i></div>');

    // Ajax call
    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&event_id=' + event_id + '&action=load_event_wait_list_popup',
        success: function(response) {
            var res = JSON.parse(response);

            $(container).empty().append(res);
        },
    })
});

// Buttons interested/participate on event -------------------------------- END

// NEW Buttons interested/participate on event ------------------------------ NEW START
$(document).on('click touch', '.event-btn', function(e) {
    e.preventDefault();
    $('body').addClass('is-loading');
    var button = this;


    var otherButtonClass = $(button).hasClass("participation-btn")? "interested-btn" : "participation-btn" ;
    var thisButtonClass = $(button).hasClass("participation-btn")? "participation-btn" : "interested-btn" ;

    var parentFormClass = "." + button.getAttribute('data-parent-form-class');


    // Set params
    var user = button.getAttribute('data-user-id');
    var event = button.getAttribute('data-event-id');
    var action = button.getAttribute('data-action');
    var action_function = '';


    // Determine which action to use
    if (action === 'participation') {
        action_function = 'create_participation';

    } else if (action === 'interested') {
        action_function = 'create_interest';
    }

    // Ajax call
    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&user_id=' + user + '&event_id=' + event + '&action=' + action_function,
        success: function(response) {
            var res = JSON.parse(response);
            swal({
                title: res.message.title,
                html: res.message.message,
                type: res.message.type
            });

            $(parentFormClass).each(function() {

                var selfForm = $(this);
                var otherButton = $(selfForm).find("." + otherButtonClass);
                var thisButton = $(selfForm).find("." + thisButtonClass);

                // Update participate/interest counter
                if (res.hasOwnProperty('count') && res.count !== null ) {
                    if (res.count.hasOwnProperty('participation')) {
                        $(selfForm).find('.event-listing__count--participate-' + res.count.event_id).text(res.count.participation);
                    }

                    if (res.count.hasOwnProperty('interest')) {
                        $(selfForm).find('.event-listing__count--interest-' + res.count.event_id).text(res.count.interest);
                    }
                }

                if (res.count.hasOwnProperty('status') && res.count.status == "1") { // Interested
                    $(thisButton).prop('checked', true);
                    $(otherButton).prop('checked', false);
                    $(selfForm).find(".form-event-participation__p-span").removeClass("form-event-participation__p-span--waiting");
                    $(selfForm).find(".load-waiting-popup").hide();

                    if ($(thisButton).attr("data-is-full") == 1) {
                        $(selfForm).find(".agenda-item__participation__text--participation").html(ilioPost.eventJoinQueueWording);
                    } else {
                        $(selfForm).find(".agenda-item__participation__text--participation").html(ilioPost.eventParticipatingWording);
                    }

                } else if (res.count.hasOwnProperty('status') && res.count.status == "2") { // Participating
                    $(thisButton).prop('checked', true);
                    $(otherButton).prop('checked', false);
                    $(selfForm).find(".agenda-item__participation__text--interested").html(ilioPost.eventInterestingWording);
                    $(selfForm).find(".agenda-item__participation__text--participation").html(ilioPost.eventNoParticipatingWording);
                    $(selfForm).find(".form-event-participation__p-span").removeClass("form-event-participation__p-span--waiting");

                }else if (res.count.hasOwnProperty('status') && res.count.status == "3") { // Waiting
                    $(thisButton).prop('checked', true);
                    $(otherButton).prop('checked', false);
                    //Add waiting class to participation span
                    $(selfForm).find(".form-event-participation__p-span").addClass("form-event-participation__p-span--waiting");
                    //
                    $(selfForm).find(".agenda-item__participation__text--participation").html(ilioPost.eventWaitingWording);
                    $(selfForm).find(".agenda-item__participation__text--interested").html(ilioPost.eventInterestingWording);

                    $(selfForm).find(".load-waiting-popup").show();

                }else if (res.count.hasOwnProperty('status') && res.count.status == "allready_waiting") { // Allready waiting


                } else if (res.count.hasOwnProperty('status') && res.count.status == "0") {
                    $(otherButton).prop('checked', false);
                    $(thisButton).prop('checked', false);
                    $(selfForm).find(".form-event-participation__p-span").removeClass("form-event-participation__p-span--waiting");
                    $(selfForm).find(".agenda-item__participation__text--interested").html(ilioPost.eventInterestingWording);
                    $(selfForm).find(".agenda-item__participation__text--participation").html(ilioPost.eventParticipatingWording);
                } else {
                    $(thisButton).prop('checked', false);

                    if (action === 'participation') {
                        $(selfForm).find(".form-event-participation__p-span").removeClass("form-event-participation__p-span--waiting");
                        $(selfForm).find(".agenda-item__participation__text--participation").html(ilioPost.eventParticipatingWording);
                        $(thisButton).prop('checked', true);

                    }

                }
            });
        },
    }).always(function () {
        $('body').removeClass('is-loading');
    });
});

// NEW Buttons interested/participate on event -------------------------------- NEW END

// Accept or refuse a released place on event  -------------------------- START
$('.form-released-place-event').on('submit', function(e) {
    e.preventDefault();
    $('body').addClass('is-loading');
    var button = this;

    // Set params
    var user = button.getAttribute('data-user-id');
    var event = button.getAttribute('data-event-id');
    var answer = button.getAttribute('data-answer');
    var notification = button.getAttribute('data-notification-id');

    // Ajax call
    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&user_id=' + user + '&event_id=' + event + '&answer=' + answer + '&notification_id=' + notification + '&action=update_queue_from_user_answer',
        success: function(response) {
            var res = JSON.parse(response);
            swal({
                title: res.message.title,
                html: res.message.message,
                type: res.message.type
            });
            document.location.reload();
        },
    }).always(function () {
        $('body').removeClass('is-loading');
    });
});
// Accept or refuse a released place on event  ---------------------------- END


// Invite users to event  -------------------------- START

$(document).on("click touchstart", ".event-invite-user", function(e) {

    var user_to_invite_id = $(this).attr("data-user-id");
    var user_inviting_id = $(this).attr("data-current-user-id");
    var event_id = $(this).attr("data-event-id");

    e.preventDefault();
    $('body').addClass('is-loading');
    var button = this;

    $.ajax({
        'url': ajaxurl,
        'type': 'GET',
        'data': '&user_id=' + user_to_invite_id + '&event_id=' + event_id + '&inviting_user_id=' + user_inviting_id + '&action=invite_to_event',
        success: function(response) {
            var res = JSON.parse(response);
            swal({
                title: res.message.title,
                html: res.message.message,
                type: res.message.type
            })
        },
    }).always(function () {
        $('body').removeClass('is-loading');
    });

});

// Invite users to event  ---------------------------- END

// Event's filters ------------------------------------------------------ START

$(function() {

    var autocomplete;

    if (typeof google != "undefined") {
        google.maps.event.addDomListener(window, 'load', init);

        function init() {
            // Create the autocomplete object, restricting the search to geographical
            // location types.
            autocomplete = new google.maps.places.Autocomplete(
                (document.getElementById('events-address')),
                {
                    types: ['(cities)']
                }
            );
        }
    }

    /*
     * Google Maps input autocomplete
     */



    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    function geolocate() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                var circle = new google.maps.Circle({
                    center: geolocation,
                    radius: position.coords.accuracy
                });
                autocomplete.setBounds(circle.getBounds());
            });
        }
    }

    $('#events-address').on('focus', function() {
        init();
        geolocate();
    });
});

// Event's filters -------------------------------------------------------- END


$('.agenda-item__date').on('click', function() {
   var target = $(this).data('target');
   $(target).modal('show');
});


// Event's filters -------------------------------------------------------- END


$('.agenda-item__date').on('click', function() {
    var target = $(this).data('target');
    $(target).modal('show');
});